import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-white px-4 md:px-6 py-6 rounded-lg shadow-sm flex items-center mb-6"
}
const _hoisted_2 = { class: "bg-blue-100 w-20 h-20 rounded-lg items-center justify-center flex-shrink-0 mr-4 hidden md:flex" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "" }, "Click here to update your profile and get the best matches for you!", -1)
const _hoisted_4 = { class: "bg-white flex flex-col shadow rounded-lg relative" }
const _hoisted_5 = {
  key: 0,
  class: "md:absolute right-0 bottom-full mb-4 md:mb-10"
}
const _hoisted_6 = {
  key: 1,
  class: "px-4 py-5 flex justify-between items-center"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  href: "#",
  class: "text-gray-600 text-hover-primary mb-1"
}
const _hoisted_10 = {
  href: "#",
  class: "text-gray-600 text-hover-primary mb-1"
}
const _hoisted_11 = {
  href: "#",
  class: "text-gray-600 text-hover-primary mb-1"
}
const _hoisted_12 = {
  href: "#",
  class: "text-gray-600 text-hover-primary mb-1"
}
const _hoisted_13 = { class: "text-gray-600" }
const _hoisted_14 = { class: "text-gray-600" }
const _hoisted_15 = { class: "text-gray-600" }
const _hoisted_16 = { class: "flex justify-end" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 1,
  class: "py-2 px-4 bg-green-100 text-green-800 text-xs rounded-md focus:outline-none"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AnnotationIcon = _resolveComponent("AnnotationIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_deals_filter = _resolveComponent("deals-filter")!
  const _component_EyeIcon = _resolveComponent("EyeIcon")!
  const _component_data_table = _resolveComponent("data-table")!
  const _component_base_spinner = _resolveComponent("base-spinner")!
  const _component_base_pagination = _resolveComponent("base-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.accountType == 'originator')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_AnnotationIcon, { class: "text-sky w-6 h-6" })
          ]),
          _createElementVNode("div", null, [
            _hoisted_3,
            _createVNode(_component_router_link, {
              to: "/account",
              class: "inline-block bg-sky text-white px-3 py-2 rounded-md text-xs mt-2"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Update profile ")
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.accountType == 'advisor')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("button", {
              type: "button",
              class: "inline-flex items-center justify-center rounded-md bg-white text-gray-600 px-4 py-2 text-sm font-medium shadow-sm focus:outline-none hover:bg-gray-100",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.showModal('ModalNewDeal')), ["prevent"]))
            }, " Create Deal ")
          ]))
        : _createCommentVNode("", true),
      (_ctx.accountType !== 'originator')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_deals_filter, { blocked: _ctx.loading }, null, 8, ["blocked"])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.loading)
        ? (_openBlock(), _createBlock(_component_data_table, {
            key: 2,
            tableData: _ctx.deals,
            tableHeader: _ctx.tableHeader,
            class: _normalizeClass(["rounded-tl-lg rounded-tr-lg", { 'md:rounded-none': _ctx.accountType == 'advisor' }])
          }, {
            "cell-customer": _withCtx(({ row: deal }) => [
              _createElementVNode("div", null, [
                (_ctx.accountType == 'advisor')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.getName(deal?.customerData?.fullName)), 1))
                  : (_ctx.accountType == 'originator')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(deal.name), 1))
                    : _createCommentVNode("", true)
              ])
            ]),
            "cell-amount": _withCtx(({ row: deal }) => [
              _createElementVNode("a", _hoisted_9, [
                (_ctx.accountType == 'advisor')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(deal.data["Loan amount"] ? '$' + _ctx.convertToCurrency(deal.data["Loan amount"]) : 'Pending Data'), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(deal.loanAmount ? '$' + _ctx.convertToCurrency(deal.loanAmount) : 'Pending Data'), 1)
                    ], 64))
              ])
            ]),
            "cell-purpose": _withCtx(({ row: deal }) => [
              _createElementVNode("a", _hoisted_10, [
                (_ctx.accountType == 'advisor')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(deal.data["Loan purpose"] || 'Pending Data'), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(deal.loanPurpose || 'Pending Data'), 1)
                    ], 64))
              ])
            ]),
            "cell-state": _withCtx(({ row: deal }) => [
              _createElementVNode("a", _hoisted_11, [
                (_ctx.accountType == 'originator')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(deal.propertyAddress ? `${deal.propertyAddress.locality}, ${deal.propertyAddress.administrative_area_level_1}` : 'Pending Data'), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(!!deal.data["Property address"] ? deal.data["Property address"].administrative_area_level_1 : 'Pending Data'), 1)
                    ], 64))
              ])
            ]),
            "cell-type": _withCtx(({ row: deal }) => [
              _createElementVNode("a", _hoisted_12, [
                (_ctx.accountType == 'advisor')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(deal.type), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(deal.propertyType || deal.type || 'Pending Data'), 1)
                    ], 64))
              ])
            ]),
            "cell-status": _withCtx(({ row: deal }) => [
              _createElementVNode("span", _hoisted_13, _toDisplayString(deal.status), 1)
            ]),
            "cell-created": _withCtx(({ row: deal }) => [
              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.moment(deal.created)), 1)
            ]),
            "cell-updated": _withCtx(({ row: deal }) => [
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.moment(deal.updated) || '-'), 1)
            ]),
            "cell-details": _withCtx(({ row: deal }) => [
              _createElementVNode("div", _hoisted_16, [
                (_ctx.accountType == 'advisor')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (deal.offeringMemorandumId)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            class: "px-3 py-2 bg-white border text-xs rounded-md hover:border-gray-400 mr-2 flex items-center",
                            to: `/offering-memorandum/${deal.offeringMemorandumId || ''}`
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_EyeIcon, { class: "w-3 h-3 mr-1" }),
                              _createTextVNode(" OM ")
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_router_link, {
                        to: { name: 'deal', params: { id: deal.id } },
                        class: "py-2 px-3 bg-sky text-white text-xs rounded-md focus:outline-none"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Details ")
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ], 64))
                  : (_ctx.accountType == 'originator')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (deal.offeringMemorandumId)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (_ctx.distributionsByOmId[deal.offeringMemorandumId])
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 0,
                                    class: "px-3 py-2 bg-white border text-xs rounded-md hover:border-gray-400 mr-2 flex items-center",
                                    to: `/offering-memorandum/${deal.offeringMemorandumId}/distribution/${_ctx.distributionsByOmId[deal.offeringMemorandumId].id}/share-code/${_ctx.distributionsByOmId[deal.offeringMemorandumId].shareCode}`
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_EyeIcon, { class: "w-3 h-3 mr-1" }),
                                      _createTextVNode(" Details ")
                                    ]),
                                    _: 2
                                  }, 1032, ["to"]))
                                : (_openBlock(), _createBlock(_component_router_link, {
                                    key: 1,
                                    class: "px-3 py-2 bg-white border text-xs rounded-md hover:border-gray-400 mr-2 flex items-center",
                                    to: `/offering-memorandum/${deal.offeringMemorandumId}/originator/${_ctx.profile.originatorId}`
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_EyeIcon, { class: "w-3 h-3 mr-1" }),
                                      _createTextVNode(" Details ")
                                    ]),
                                    _: 2
                                  }, 1032, ["to"]))
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              (!_ctx.inquiries.includes(deal.id))
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    href: "#inquire",
                                    class: "py-2 px-3 bg-sky text-white text-xs rounded-md focus:outline-none",
                                    onClick: _withModifiers(($event: any) => (_ctx.showModal('ModalInquireDealDetails', { deal: deal })), ["prevent"])
                                  }, " Inquire details ", 8, _hoisted_17))
                                : (_openBlock(), _createElementBlock("span", _hoisted_18, " Inquired "))
                            ], 64))
                      ], 64))
                    : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["tableData", "tableHeader", "class"]))
        : (_openBlock(), _createBlock(_component_base_spinner, {
            key: 3,
            class: "h-80 rounded-lg"
          })),
      _createVNode(_component_base_pagination, {
        pagingData: _ctx.paging,
        onCurrentChange: _ctx.onPageChange
      }, null, 8, ["pagingData", "onCurrentChange"])
    ])
  ], 64))
}